export const SUBMIT_FORM_DATA = 'SUBMIT_FORM_DATA';

export const POLICYGENIUS_PHONE_NUMBER = '1-855-695-2255';
export const POLICYGENIUS_EMAIL = 'pcbusiness@policygenius.com';
export const POLICYGENIUS_PRIVACY_EMAIL = 'privacy@policygenius.com';
export const PRIVACY_URL = 'https://www.policygenius.com/about/privacy/';
export const CONSENT_URL = 'https://www.policygenius.com/about/electronic-business/';
export const TERMS_URL = 'https://www.policygenius.com/about/terms/';
export const SIGN_IN_OPTION = {
  url: '/users/sign_in',
  text: 'Sign in',
};

export const PRIMARY_APPLICANT_TYPE = 'primary';

export const CO_APPLICANT_TYPE = 'co_applicant';

export const HOME_VERTICAL = 'HOME';
export const AUTO_VERTICAL = 'AUTO';
